import AppFrame from '@/components/AppFrame';
import { LS_SELECTED_PID_KEY } from '@/components/AppProfileSelect';
import { useViewerQuery } from '@/generated/graphql';
import { useLocalStorage } from '@/hooks/local-storage';
import { find } from 'lodash';
import { useRouter } from 'next/router';
import React from 'react';

export default function Index(): JSX.Element {
  const router = useRouter();
  const localStorage = useLocalStorage();
  const { loading, data } = useViewerQuery();

  if (!loading) {
    if (data?.viewer) {
      let pid = localStorage.getUserItem(LS_SELECTED_PID_KEY);

      if (!pid || !find(data.viewer.profiles, { pid })) {
        pid = data.viewer.profiles[0]?.pid;
      }

      if (pid) {
        router.replace(`/p/${pid}`);
      }
    } else {
      router.replace('/signin');
    }
  }

  return (
    <AppFrame user={data?.viewer}>
      <div />
    </AppFrame>
  );
}
